<template>
  <div className="animated">
    <b-row class="my-2">
      <b-col>
        <h1 class="text-uppercase font-weight-bold">Listado de Inspecciones Recepcion por Lote</h1>
      </b-col>
    </b-row>
    <!-- <email-modal> -->
    <server-filterable-table
      ref="serverTable"
      :downloadeable="false"
      :column_display="column_display"
      :columns="columns"
      :filterable="filterable"
      :headings="headings"
      :listColumns="listColumns"
      :url="url"
      :clickable="true"
      :action-buttons="action_buttons"
      @on-loading="loading = $event"
      @on-link-action="goToExternalLink"
      @on-download-action="downloadPDF"
      @on-send-action="emailPDF"
    >
      <template slot="lot.number" slot-scope="props">
        {{ props.row.lot.number }}
        <email-modal
          :to="to"
          :cc="cc"
          :modalId="'email-modal' + props.row.id"
          :item="props.row"
          ep_url="/api/v1/qc/email_pdf/"
          method="post"
          :msg="getMsg(props.row)"
          :subject="subject"
          @onSend="refreshTable"
        />
      </template>
      <div slot="last_clasification" slot-scope="props">
        <b-badge :variant="props.row.last_color">
          {{ props.row.last_clasification }}
        </b-badge>
      </div>
    </server-filterable-table>
  </div>
</template>

<script>
import ServerFilterableTable from "@/bagno_views/ServerFilterableTable";
import EmailModal from "../reusable/EmailModal2023.vue";
export default {
  name: "InspectionList",
  components: {
    ServerFilterableTable,
    EmailModal
  },
  data() {
    return {
      subject: "Inspección de Lote",
      to: "",
      cc: "",
      items: [],
      selectedItems: [],
      url: "/api/qc/lotqc/",
      title: "Listado de Inspecciones",
      loading: false,
      action_buttons: ["download", "send"],
      columns: ["id", "lot.number", "company_name", "created_at", "clasification", "status", "actions"],
      filterable: [
        "lot.number",
        "company_name",
        "data.PCT_Grower",
        "data.PCT_Variety",
        "data._L_Name_Product",
        "pallet_number",
        "external_id"
      ],
      headings: {
        actions: "Acciones",
        "lot.number": "Lote",
        clasification: "Nota final",
        pallet_number: "Pallet",
        created_at: "Fecha Inspección",
        "data.PCT_Grower": "Productor",
        "data.PCT_Variety": "Variedad",
        "data._L_Name_Product": "Tipo"
      },
      listColumns: {}
    };
  },
  methods: {
    getMsg(item) {
      return `Estimado Productor,\n\nSe adjunta el resultado de la inspección realizada a su lote número ${item.lot.number}.\n\nAtte.,\n\nEquipo de Calidad`;
    },
    getEmails(item) {
      this.$axios({
        method: "get",
        url: "/reports/arrival_emails/" + item.company_id
      })
        .then((res) => {
          this.to = res.data.emails.to.join(",");
          this.cc = res.data.emails.cc.join(",");
          // this.bcc = res.data.emails.bcc.join();
        })
        .catch((error) => {});
    },
    forceFileDownload(response, filename) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename); //or any other extension
      document.body.appendChild(link);
      link.click();
    },
    refreshTable() {
      this.$refs.serverTable.resetFilters();
    },

    goToExternalLink(item) {
      window.open(item.data._L_Link_Web, "_blank");
    },
    async downloadPDF(eve) {
      this.loading = true;
      try {
        const res = await this.$axios.get(`/api/v1/qc/download_pdf/${eve.id}`, {
          responseType: "arraybuffer"
        });
        this.forceFileDownload(res, `Inspeccion Lote ${eve.lot.number}.pdf`);
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    async emailPDF(eve) {
      await this.getEmails(eve);
      this.$bvModal.show("email-modal" + eve.id);
    }
  }
};
</script>

<style></style>
